import { paymentTypesActions } from './paymentTypes-slice'
import store from './index'
import { handleError, handleSessionExpired } from './error-handler';

export const fetchPaymentTypesList = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(paymentTypesActions.setIsLoading(true))
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/paymenttypes',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch payment types list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const paymentTypesData = await fetchData()
            dispatch(paymentTypesActions.loadPaymentTypes({ paymentTypes: paymentTypesData || [] }))
        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(paymentTypesActions.setIsLoading(false))

        }
    };
};


export const setPaymentTypesIsLoading = (value) => {
    return (dispatch) => {
        dispatch(paymentTypesActions.setIsLoading(value))
    }
}



